<template>
  <b-btn data-test-path="header-show-picture-button" @click="sendIntegration"
         ref="sendIntegration"
         :title="$tr('subiektIntegrationLabel','Subiekt integration')"
         variant="plm-toolbar-secondary" class="m-1 d-flex align-items-center justify-center flex-column"
         style="width: 42px; height: 38px; padding-right: 6px !important; padding-left: 6px !important;">
    <b-row class="d-flex w-100" style="justify-content: flex-end; transform: translate(5px, -5px) !important; ">
      <div
          ref="led"
          class="bg-secondary border border-light rounded-circle"
          style="width: 10px; height: 10px;"
      ></div>
    </b-row>
    <b-row style="transform: translate(0px, -5px) !important; ">
      <font-awesome-icon icon="sync"/>
    </b-row>
  </b-btn>
</template>

<script>

import RoutingKeys from "@/server/RoutingKeys";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import Rpc from "@/Rpc";
import IntegrationStatuses from "@/server/com/silkplm/model/plm/dictionaries/IntegrationStatuses";
import FormValidatedField from "@/components/forms/FormValidatedField";

export default {
  name: "SubiektIntegrationSyncButton",

  mounted() {
    this.$subscribe(RoutingKeys.RK_SUBIEKT_INTEGRATION_STATUS, async message => {
      if (message.statusId !== "null") {
        this.setAsSuccess()
        this.form.validatedFieldByName("stateOfSubiektIntegration")._value = message.statusId;
      } else {
        this.setAsError();
      }
    });
  },

  methods: {
    setAsError() {
      this.$refs.led.classList.remove("bg-secondary");
      this.$refs.led.classList.remove("bg-success");
      this.$refs.led.classList.add("bg-danger");
      this.$refs.sendIntegration.disabled = false;
    },

    setAsSuccess() {
      this.$refs.led.classList.remove("bg-secondary");
      this.$refs.led.classList.remove("bg-danger");
      this.$refs.sendIntegration.disabled = true;
      this.$refs.led.classList.add("bg-success");
    },

    async prepareButtonState(stateOfSubiektIntegration) {
      if (stateOfSubiektIntegration == null) {
        this.$refs.sendIntegration.disabled = false;
        this.$refs.led.classList.add("bg-secondary");
        return;
      }

      let integrationStatus = new IntegrationStatuses();
      await integrationStatus.load(stateOfSubiektIntegration);
      if (integrationStatus.name === "Integrated") {
        this.$refs.sendIntegration.disabled = true;
        this.$refs.led.classList.add("bg-success");
      } else if (integrationStatus.name === "Integration Error") {
        this.$refs.sendIntegration.disabled = false;
        this.$refs.led.classList.add("bg-danger");
      }
    },

    async sendIntegration() {
      // let integrationElements = await Rpc.plm.services.integrations.SubiektIntegrationService.checkIntegrationElements(this.entityInstance.id);
      // let checkIntegrationDates = await Rpc.plm.services.integrations.SubiektIntegrationService.checkIntegrationDates(this.entityInstance.id);
      let checkIntegrationState = await Rpc.plm.services.integrations.SubiektIntegrationService.checkIntegrationState(this.entityInstance.id);
      if(checkIntegrationState != null && checkIntegrationState.length > 0){
        await DialogManager.info($tr('entitie.send.subiect.integration.checkIntegrationState.popup.title', 'Sending Subiekt integration Error'),
            $tr('entitiesList.send.subiect.integration.checkIntegrationState.popup.body', "Please set 'Subiekt Integration Status' to 'to be integrated'"));
        return;
      }
      // if (integrationElements != null && integrationElements.length > 0) {
      //   this.setAsError();
      //   let listOfWrongElements = "";
      //   for (let element of integrationElements) {
      //     listOfWrongElements += element + ", "
      //   }
      //   await DialogManager.info($tr('entitie.send.subiect.integration.wrong.data.popup.title', 'Sending Subiekt integration Error'),
      //       $tr('entitiesList.send.subiect.integration.wrong.data.popup.body', "Following data are missing: ")
      //       + listOfWrongElements.slice(0, listOfWrongElements.length - 2)
      //   );
      // }
      // if (integrationElements == null ) {
      //   await DialogManager.info($tr('entitie.send.subiect.integration.server.error.popup.title', 'Sending Subiekt integration Error'),
      //       $tr('entitiesList.send.subiect.integration.server.error.popup.body', "Server error please contact with developers."));
      // } else if(checkIntegrationDates !== null && checkIntegrationDates.length > 0){
      //   let listOfWrongElements = "";
      //   for (let element of checkIntegrationDates) {
      //     listOfWrongElements += element + ", "
      //   }
      //   await DialogManager.info($tr('entitie.send.subiect.integration.dates.error.popup.title', 'Sending Subiekt integration Error'),
      //       $tr('entitiesList.send.subiect.integration.server.dates.popup.body', "Following date missing: ")
      //       + listOfWrongElements.slice(0, listOfWrongElements.length - 2));
      // } else {
      let confirmed = await DialogManager.yesNo($tr('entitie.send.subiekt.integration.popup.title', 'Sending Subiekt integration'),
          $tr('entitiesList.send.subiekt.integration.popup.body', 'Are you sure you want to send this tranche to Subiekt?'), false);
      if (confirmed) {
        await Rpc.plm.services.integrations.SubiektIntegrationService.sendIntegrationToSubiekt(this.entityInstance.id).lock();
      }
      // }
    }
  },

  props: {
    entityInstance: {default: null},
    form: {default: null},
    validatedField: {type: FormValidatedField, required: true},
  },

  watch: {
    entityInstance: async function (val) {
      await this.prepareButtonState(val.stateOfSubiektIntegration);
    },
    "entityInstance.stateOfSubiektIntegration": async function (val) {
      await this.prepareButtonState(val);
    },
  },

  data: () => ({
    syncState: false
  })
}
</script>
